<div class="card">
    <span class="card-name">{{title}}</span>
    <img class="icon" src="{{iconPath}}" />
</div>